import {Navigate, useLocation, useRoutes} from 'react-router-dom';
// config
import {PATH_AFTER_LOGIN} from 'src/config-global';
//
import {mainRoutes} from './main';

import {authRoutes} from './auth';
import {dashboardRoutes} from './dashboard';
import {registersRoutes} from './registers';
import {employeesRoutes} from './employees';
import {transportsRoutes} from './transports';
import {createBrowserHistory} from 'history';
import {usePermission} from 'src/hooks/use-permission';
import {useSelector} from 'react-redux';
import {docTemplatesRoutes} from './doc-templates';
import {endpointsRoutes} from './endpoints';
import {reportDetailsRoutes} from './report-details';

// ----------------------------------------------------------------------

const history = createBrowserHistory()

export function RedirectWithParams({to}) {
  const {search} = useLocation();
  const inputParams = new URLSearchParams(search);

  const state = inputParams.get('state');
  const code = inputParams.get('code');

  const targetParams = new URLSearchParams();
  if (state) targetParams.set('state', state);
  if (code) targetParams.set('code', code);

  const finalTo = targetParams.toString() ? `${to}?${targetParams}` : to;

  return <Navigate to={finalTo} replace />;
}

const router = function Router() {
  const {isApprover, isCreator} = usePermission()
  const permissions = useSelector(store => store.user?.permissions)

  const role = permissions?.user_data?.role

  const bidBlocks = useSelector(state => state.app.settings.bidBlocks)

  const isAuto = bidBlocks?.auto?.display

  return useRoutes([
    {
      path: '/',
      element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    },

    ...authRoutes,

    ...dashboardRoutes,

    ...docTemplatesRoutes,

    ...endpointsRoutes,

    ...(isAuto ? transportsRoutes : []),

    ...((isCreator || isApprover) ? registersRoutes : []),

    ...((role === 'merchant-admin') ? employeesRoutes : []),

    ...reportDetailsRoutes,

    ...mainRoutes,

    // No match 404
    {path: '*', element: <Navigate to="/operations" replace />},
  ]);
}
export default router
export {router}
